import { FetchError } from '../http/FetchError';
export function translate(key, replaces) {
    return key.replace(/\{\{([^}]+)\}\}/gi, function (_match, k) {
        return replaces[k.trim()] || '';
    });
}
export function getTranslations(path) {
    return fetch(path, {
        method: 'get',
    })
        .then(function (response) { return response.json(); })
        .catch(function (e) {
        throw new FetchError("Could not fetch " + path, { originalError: e.message });
    });
}
export function isWorker() {
    return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}
//# sourceMappingURL=utils.js.map